/* eslint-disable max-classes-per-file */
class BaseError extends Error {
  constructor(message, errors) {
    super(message);
    if (errors) {
      this.errors = errors;
    }
  }
}
export const BASE_ERROR_MESSAGES = {
  400: 'Bad Request',
  401: 'Not authorized',
  403: 'Forbidden',
  404: 'Not found',
  422: 'Unprocessable entity',
  500: 'Server Error',
};
export class UnprocessableError extends BaseError {
  constructor(message = BASE_ERROR_MESSAGES[422], errors) {
    super(message, errors);
    this.status = 422;
    this.name = 'Unprocessable entity';
  }
}

export class NotFoundError extends BaseError {
  constructor(message = BASE_ERROR_MESSAGES[404], errors) {
    super(message, errors);
    this.status = 404;
    this.name = 'Not found';
  }
}

export class NoAccessError extends Error {
  constructor(message = BASE_ERROR_MESSAGES[403], errors) {
    super(message, errors);
    this.status = 403;
    this.name = 'No Access';
  }
}
export class NotAuthorizedError extends Error {
  constructor(message = BASE_ERROR_MESSAGES[401], errors) {
    super(message, errors);
    this.status = 401;
    this.name = 'Not authorized';
  }
}
export class BadRequestError extends Error {
  constructor(message = BASE_ERROR_MESSAGES[400], errors) {
    super(message, errors);
    this.status = 400;
    this.name = 'Bad request';
  }
}
export class ServerError extends Error {
  constructor(message = BASE_ERROR_MESSAGES[500], errors) {
    super(message, errors);
    this.status = 500;
    this.name = 'Server Error';
  }
}
export const ERROR_MESSAGES_BY_CODE = {
  emailTaken: 'This is email is already in use',
  invalidCredentials: 'Invalid credentials',
  tooManyAttempts: 'Too many attempts, try again in a few minutes',
};

export const NOT_AUTHORIZED_ERROR = new NotAuthorizedError(BASE_ERROR_MESSAGES[401]);
export const EMAIL_IN_USE_ERROR = new NoAccessError(ERROR_MESSAGES_BY_CODE.emailTaken);
export const TOO_MANY_ATTEMPTS = new NoAccessError(ERROR_MESSAGES_BY_CODE.tooManyAttempts);
export const INVALID_CREDENTIALS_ERROR = new NoAccessError(
  ERROR_MESSAGES_BY_CODE.invalidCredentials,
);
